export default "__VITE_ASSET__f9d61a13__"